import style from "./Hamburger.module.css";

import { useNavigate, NavLink, Link } from "react-router-dom";

import { FaSignOutAlt, FaUserCircle, FaLongArrowAltLeft, FaCalendarAlt, FaBars } from "react-icons/fa";

function Hamburger({rootContext}) {
    const navigate = useNavigate();
    function handleLogout() {
    rootContext.setUser(null);
    rootContext.setIsUserAdmin(false);

    navigate("/");
  }
    return (
        <div className={style.hamburger}>
            <Link to="https://ttj.sisc.ro/"
                className={`${style.navItem} ${style.onHover}`}
            >
                <FaLongArrowAltLeft className={style.icon}></FaLongArrowAltLeft>
                Înapoi la site
            </Link>

            <NavLink to="/" className={({ isActive }) => isActive ? `${style.navItem} ${style.onHover} ${style.active}` : `${style.navItem} ${style.onHover}`}>
                <FaUserCircle className={style.icon} />
                Profil
            </NavLink>

            <NavLink to="/interviu" className={({ isActive }) => isActive ? `${style.navItem} ${style.onHover} ${style.active}` : `${style.navItem} ${style.onHover}`}>
                <FaCalendarAlt className={style.icon} />
                Interviu
            </NavLink>

            <div
                onClick={handleLogout}
                className={`${style.navItem} ${style.onHover}`}
            >
                <FaSignOutAlt className={style.icon}></FaSignOutAlt>
                <p>Logout</p>
            </div>
        </div>
    )
}

export default Hamburger;

